export default __webpack_public_path__ + "static/media/banner.aef876ec.jpeg";